import { defaultTo, pipe } from 'remeda';
import type { PaginatedResponse, PaginatedResult } from '@types';

export const normalizePaginatedResponse = <T>(
  response?: PaginatedResponse<T> | null
): PaginatedResult<T> =>
  pipe(
    response,
    res => ({
      res,
      items: defaultTo(res?.items, res?.data),
    }),
    ({ res, items }) => {
      const normalizedItems = defaultTo(items, [] as T[]);
      const fallbackCount = normalizedItems.length;

      return {
        items: normalizedItems,
        page: defaultTo(res?.page, 1),
        pageSize: defaultTo(res?.pageSize, fallbackCount),
        total: defaultTo(res?.total, fallbackCount),
      };
    }
  );

export const createEmptyPaginatedResult = <T>(
  defaults?: Partial<Omit<PaginatedResult<T>, 'items'>>
): PaginatedResult<T> => ({
  items: [],
  page: defaults?.page ?? 1,
  pageSize: defaults?.pageSize ?? 0,
  total: defaults?.total ?? 0,
});
